export enum MuiMessages {
  autocompleteNoOptions = "mui.autocomplete.noOptions",
  autocompleteLoading = "mui.autocomplete.loading"
}

export interface TranslationMuiMessages {
  [MuiMessages.autocompleteNoOptions]: string;
  [MuiMessages.autocompleteLoading]: string;
}
